import { cn } from '@parcel/ui';
import type { SignalScope } from '../../lib/signals.js';

const SCOPES: readonly SignalScope[] = ['subscribed', 'all'];

/**
 * Segmented "Subscribed | All" control shared by the account and project signal
 * drawers. "Subscribed" limits the feed to signal types the workspace tracks.
 */
export function SignalScopeToggle({
  scope,
  onScopeChange,
}: {
  scope: SignalScope;
  onScopeChange: (scope: SignalScope) => void;
}) {
  return (
    <div className="inline-flex rounded-md border bg-background p-0.5">
      {SCOPES.map((value) => (
        <button
          key={value}
          type="button"
          className={cn(
            'rounded px-3 py-1 text-xs font-medium capitalize text-muted-foreground transition-colors',
            scope === value && 'bg-muted text-foreground',
          )}
          onClick={() => onScopeChange(value)}
        >
          {value}
        </button>
      ))}
    </div>
  );
}
